import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'app-dialog-export-mst',
  templateUrl: './dialogexportmst.component.html',
  styleUrls: ['./dialogexportmst.component.scss']
})
export class DialogExportMstComponent {
  @ViewChild('confirmDialog') confirmDialog: ModalDirective;

  @Input() title: string;
  @Input() totalAmountOfLocations: number;
  @Input() amountOfUnValidatedLocations: number;
  @Input() amountOfCorrectAndInactiveLocations: number;

  @Output() onConfirm = new EventEmitter<boolean>();
  @Output() onCancel = new EventEmitter<boolean>();

  public amountOfLocationsToExport: number;

  public show(): void {
    this.amountOfLocationsToExport =
      this.totalAmountOfLocations - this.amountOfUnValidatedLocations - this.amountOfCorrectAndInactiveLocations;
    this.confirmDialog.show();
  }

  public hide(): void {
    this.confirmDialog.hide();
  }

  public confirm(soapEnvelope: boolean): void {
    this.confirmDialog.hide();
    this.onConfirm.emit(soapEnvelope);
  }

  public cancel(): void {
    this.confirmDialog.hide();
    this.onCancel.emit(false);
  }

  public locationsToExport(): boolean {
    return this.amountOfLocationsToExport > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-export-mst/dialogexportmst.component.ts